<template>
  <div class="relative d-flex flex-column">
    <label :for="id" class="form-label">
      {{ name }}
      <span v-if="required === true" class="text-danger">*</span>
    </label>
    <select
      :id="id"
      v-model="model"
      :name="name"
      :class="[
        size ? `form-select form-select-${size}` : 'form-select',
        {'is-invalid': error.length > 0 && serverError === true},
        {'is-valid': error.length === 0 && serverError === true},
      ]"
      :disabled="disabled"
      :aria-label="ariaLabel || name"
      :required="required"
    >
      <option disabled selected value="">{{ placeholder }}</option>
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option"
        :selected="option === model"
      >
        <slot :option="option">
          {{ option }}
        </slot>
      </option>
    </select>
    <span role="alert" class="text-danger invalid-feedback">
      {{ error.length > 0 ? error : `${name} is required` }}
    </span>
  </div>
</template>
<script lang="ts" setup>
import {type BootstrapSelectProps} from '@/components/shared/bootstrap/forms/BootstrapSelect/BootstrapSelect.types';

const {
  modelValue,
  name,
  error = '',
  placeholder = 'Please choose an option',
} = defineProps<BootstrapSelectProps>();

const emit = defineEmits<{'update:modelValue': [value: string]}>();

const model = computed({
  get: () => modelValue,
  set: (value: string) => emit('update:modelValue', value),
});

const id = computed(() => name.toLowerCase().replace(' ', ''));
</script>
